export const adminOrgUsers = (params: { organizationId: number }) => `organization:${params.organizationId}`;
export const adminOrgUsersInvites = (params: { organizationId: number }) =>
  `invites:organization:${params.organizationId}`;
